export const lookupModel = (data) => ({
    value: data.uuid,
    text: data.name,
    code: data.code || '',
});
